import ReactDOM from 'react-dom/client';

import * as Sentry from '@sentry/react';
import LogRocket from 'logrocket';

import App from './App';
import { captureConfirmationToken } from './utils/confirmationToken';

async function bootstrap() {
  // First, before Sentry or LogRocket start recording page URLs: a confirmation
  // link's token must be out of the URL before anything can see it.
  captureConfirmationToken();

  if (import.meta.env.VITE_DEMO_MODE === 'true') {
    // Guided-demo build: fully offline. No Sentry/LogRocket (nothing may
    // phone home from a demo), and the canned-data adapters install BEFORE
    // the first render so no request ever escapes to a real network.
    const { installDemoMode } = await import('./demo/install');
    installDemoMode();
  } else {
    const logrocketId: string = import.meta.env.VITE_LOGROCKET_ID;
    if (logrocketId) {
      LogRocket.init(logrocketId);
    }

    if (import.meta.env.VITE_ENVIRONMENT !== 'dev') {
      Sentry.init({
        dsn: 'https://ce1d46562e5cbc340909029425e7bf6c@o1238805.ingest.us.sentry.io/4509612724125696',
        sendDefaultPii: true,
        tracesSampleRate: 1.0,
        replaysSessionSampleRate: 1.0,
        replaysOnErrorSampleRate: 1.0,
        _experiments: {
          enableLogs: true,
        },
        integrations: [
          Sentry.browserTracingIntegration(),
          Sentry.consoleLoggingIntegration({ levels: ['log', 'error', 'warn'] }),
          Sentry.replayIntegration({
            minReplayDuration: 10000,
          }),
        ],
      });
    }
  }

  ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
}

void bootstrap();
